const testimonials = [
    {
      name: "Zainab Adeyemi",
      role: "Product Manager, SwiftTech",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      message: "Faizol is a talented developer! He delivered our website on time with excellent performance and sleek design."
    },
    {
      name: "Chinedu Okafor",
      role: "CTO, NaijaDevHub",
      image: "https://randomuser.me/api/portraits/men/34.jpg",
      message: "Working with Faizol was smooth and professional. I was impressed with the attention to detail in his work."
    },
    {
      name: "Aisha Musa",
      role: "Freelance Designer",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
      message: "Faizol helped me bring my portfolio to life. He's creative, easy to work with, and technically sound!"
    },
    {
      name: "Tolu Johnson",
      role: "Founder, Lagos Startups",
      image: "https://randomuser.me/api/portraits/men/19.jpg",
      message: "Reliable, fast, and creative — that's how I describe Faizol. He exceeded my expectations!"
    },
    {
      name: "Blessing Umeh",
      role: "UX Designer, UIHub",
      image: "https://randomuser.me/api/portraits/women/50.jpg",
      message: "Faizol’s attention to detail made our project shine. I’m definitely working with him again."
    },
    {
      name: "Emeka Daniel",
      role: "Blogger & Content Creator",
      image: "https://randomuser.me/api/portraits/men/72.jpg",
      message: "His portfolio setup was perfect for my blog. It loads fast, looks clean, and works on all devices."
    }
  ];
  
  export default testimonials;
  